export const onlineStates = ['ONLINE', 'NEAR_END'];

export function isOnlinePosting(state) {
  return onlineStates.includes(state);
}
